import axios from "axios";
import { servicePath } from "../../utility/data";

export const getPieChartData = async (startDate, endDate, accessToken) => {
  try {
    const response = await axios.get(
      `${servicePath}/wealth/fortune/pie_charts?start_date=${startDate}&end_date=${endDate}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error:", error);
    throw new Error(
      error.response ? error.response.data.message : "error to getting data"
    );
  }
};

export const getDetailsAssetService = async (
  type,
  startDate,
  endDate,
  accessToken
) => {
  try {
    const response = await axios.get(
      `${servicePath}/wealth/details?type=${type}&start_date=${startDate}&end_date=${endDate}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error:", error);
    throw new Error(
      error.response ? error.response.data.message : "error to getting data"
    );
  }
};

export const getDetailsInnerService = async (
  type,
  selectedAsset,
  startDate,
  endDate,
  accessToken
) => {
  try {
    const response = await axios.get(
      `${servicePath}/wealth/detail/${selectedAsset}?type=${type}&start_date=${startDate}&end_date=${endDate}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error:", error);
    throw new Error(
      error.response ? error.response.data.message : "error to getting data"
    );
  }
};

export const getLegacyDataService = async (type, startDate, endDate, accessToken) => {
  try {
    const response = await axios.get(
      `${servicePath}/wealth/legacy?type=${type}&start_date=${startDate}&end_date=${endDate}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error:", error);
    throw new Error(
      error.response ? error.response.data.message : "error to getting data"
    );
  }
};

export const getFortuneService = async (type, startDate, endDate, accessToken) => {
  try {
    const response = await axios.get(
      `${servicePath}/wealth/fortune?type=${type}&start_date=${startDate}&end_date=${endDate}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error:", error);
    throw new Error(
      error.response ? error.response.data.message : "error to getting data"
    );
  }
};

export const getSelectedDetailsGraphService = async (
  selectedAsset,
  selected_wealth,
  startDate,
  endDate,
  accessToken
) => {
  try {
    const response = await axios.get(
      `${servicePath}/wealth/detail/${selected_wealth}/${selectedAsset}?start_date=${startDate}&end_date=${endDate}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error:", error);
    throw new Error(
      error.response ? error.response.data.message : "error to getting data"
    );
  }
};


export const getLegacyDocService = async (item_id, accessToken) => {
  try {
    const response = await axios.get(
      `${servicePath}/wealth/item_docs/${item_id}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error:", error);
    throw new Error(
      error.response ? error.response.data.message : "error to getting data"
    );
  }
};